import { inject, Injectable } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AppStateModel, selectAppState } from '../../../app.state';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { RouteNavigationService } from '../route-navigation.service';
import { Store } from '@ngxs/store';

@Injectable()
export class LoggedInRouteGuardLogic {
  constructor(
    private _store: Store,
    private _routeNavigationService: RouteNavigationService,
  ) {}

  public canActivate(): Observable<boolean> {
    return selectAppState(this._store).pipe(
      filter((state: AppStateModel) => !!state?.isInitialized),
      take(1),
      map((applicationState: AppStateModel) => {
        const isLoggedIn = !!applicationState.session;

        if (!isLoggedIn) {
          this._routeNavigationService.goToLoginAsync(true);
        }

        return isLoggedIn;
      }),
    );
  }
}

export const LoggedInRouteGuard: CanActivateFn = (): Observable<boolean> => {
  return inject(LoggedInRouteGuardLogic).canActivate();
};
